import DataTable from 'datatables.net';
import 'datatables.net-dt';
import 'datatables.net-bs5';

import { Datepicker } from 'vanillajs-datepicker';

import Coloris from "@melloware/coloris";

import './boot';
import utils from './utils';
import maps from './maps';
import graphics from './graphics';
import charts from './charts';
import jobs from './jobs';
import reportEdit from './report-edit';
import reportRender from './report-render';
import reportPreview from './report-preview';
import staticRender from './statics';
import './icons';

import 'jquery-ui/ui/version.js';
import 'jquery-ui/ui/widget.js';
import 'jquery-ui/ui/data.js';
import 'jquery-ui/ui/scroll-parent.js';
import 'jquery-ui/ui/widgets/mouse.js';
import 'jquery-ui/ui/widgets/sortable.js';

import Glide from '@glidejs/glide';

import.meta.glob([
    '../images/**',
]);

$(document).ready(function () {
    utils.init();
    let j = utils.j();

    Coloris.init();

    let reports_editor = new reportEdit();
    let reports_render = new reportRender();
    let reports_preview = new reportPreview();
    let reports_static = new staticRender();
    let map = new maps();
    let charting = new charts();
    let job = new jobs();

    j.init({
        fixBootstrap: ['Tooltip', 'Toast'],
        beforeInitFunction: function (container) {
            /*
                This is to block double-clicks on .async-modal buttons, which
                may lead to unintented behaviors
            */
            $('.async-modal', container).click((e) => {
                let node = $(e.currentTarget);
                if (node.prop('disabled')) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    return false;
                }

                node.prop('disabled', true);
                let spinner = $(j.makeSpinner());
                spinner.find('.spinner-border').addClass('spinner-border-sm');
                let contents = node.html();
                node.attr('data-old-contents', contents);
                node.css('width', node.outerWidth()).empty().append(spinner);
            }).on('jb-after-async-fetch', (e, success) => {
                let node = $(e.currentTarget);
                let contents = node.attr('data-old-contents');
                node.css('width', 'auto').prop('disabled', false).empty().append(contents);
            });
        },
        initFunction: function (container) {
            /*
                cfr. ResourceController::previewsave()
            */
            $('.triggers_changes', container).change((e) => {
                let form = $(e.currentTarget).closest('form');
                graphics.blurForm(form);
                let block = form.find('.config-block');
                let data = j.serializeForm(form);

                $.ajax({
                    url: form.attr('data-preview-url'),
                    method: 'GET',
                    data: data,
                    dataType: 'HTML',
                    success: function (res) {
                        res = $(res);
                        block.replaceWith(res);
                        j.initElements(res);
                        graphics.unblurForm(form);
                    }
                });
            });

            container.find('[data-bs-toggle="tooltip"]').each((i, el) => {
                $(el).tooltip();
            });

            $('.requires-status', container).submit((e) => {
                e.preventDefault();
                e.stopPropagation();
                let form = $(e.currentTarget);

                $.ajax({
                    url: form.attr('action'),
                    method: form.attr('method'),
                    async: false,
                    cache: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    processData: false,
                    data: new FormData(e.currentTarget),
                    dataType: 'HTML',
                    success: function (res) {
                        res = $(res);
                        res.modal('show');
                        j.initElements(res);
                    },
                    error: function () {
                        setTimeout(() => {
                            alert('Errore');
                            graphics.unblurForm(form);
                        }, 500);
                    }
                });
            });

            if ($('input.color', container).length > 0) {
                /*
                    When here, the modal has not yet been appended to the body.
                    So the Coloris plugin is not able to identify the nodes, and
                    correctly init. So we wait a few millisecond before actually
                    init the plugin, just the time for the modal to be appended
                */
                setTimeout(() => {
                    $('input.color', container).each((index, node) => {
                        node = $(node);

                        Coloris({
                            parent: '#' + node.closest('.modal').attr('id'),
                            el: '#' + node.attr('id'),
                            alpha: false,
                            swatches: [
                                '#00ca5d',
                                '#d600ff',
                                '#f7ff19',
                                '#00b8ff',
                                '#001eff',
                            ],
                        });
                    });
                }, 200);
            }

            $('.change_help', container).change((e) => {
                let select = $(e.currentTarget);
                let opt = select.val();
                let helps = window[select.attr('data-helps-variable')];
                let string = helps[opt];
                select.siblings('.form-text').text(string);
            });

            container.find('.sortable-table').sortable({
                items: 'tr',
                handle: '.dnd',
            });

            let dt_languages = {
                en: '/langs/datatables/en-GB.json',
                it: '/langs/datatables/it-IT.json',
            };

            /*
                Datatables has to be inited once; here we filter out items
                already having the .dataTable CSS class
            */

            $('.datatables', container).filter(':not(.dataTable)').DataTable({
                responsive: true,
                lengthChange: false,
                language: {
                    info: "Mostra da _START_ a _END_ di _TOTAL_ elementi",
                    infoEmpty: "Nessun elemento disponibile",
                    infoFiltered: "(filtrati da _MAX_ elementi totali)",
                    lengthMenu: "Mostra _MENU_ elementi",
                    loadingRecords: "Caricamento...",
                    processing: "Elaborazione...",
                    search: "Cerca:",
                    zeroRecords: "Nessun elemento trovato",
                    paginate: {
                        first: "Prima",
                        last: "Ultima",
                        next: "Successivo",
                        previous: "Precedente"
                    },
                    aria: {
                        sortAscending: ": attiva per ordinare in modo crescente",
                        sortDescending: ": attiva per ordinare in modo decrescente"
                    }
                }
            });

            $('.datatable-compact', container).filter(':not(.dataTable)').DataTable({
                searching: false,
                paging: false,
                info: false,
                responsive: true,
                lengthChange: false,
                language: {
                    info: "Mostra da _START_ a _END_ di _TOTAL_ elementi",
                    infoEmpty: "Nessun elemento disponibile",
                    infoFiltered: "(filtrati da _MAX_ elementi totali)",
                    lengthMenu: "Mostra _MENU_ elementi",
                    loadingRecords: "Caricamento...",
                    processing: "Elaborazione...",
                    search: "Cerca:",
                    zeroRecords: "Nessun elemento trovato",
                    paginate: {
                        first: "Prima",
                        last: "Ultima",
                        next: "Successivo",
                        previous: "Precedente"
                    },
                    aria: {
                        sortAscending: ": attiva per ordinare in modo crescente",
                        sortDescending: ": attiva per ordinare in modo decrescente"
                    }
                },
            });

            container.find('.carousel').each((i, e) => {
                let carousel = $(e);
                let slides = carousel.find('.glide__slide').length;
                let enabled = slides;
                if (slides > 6) {
                    enabled = 6;
                }

                new Glide('#' + carousel.attr('id'), {
                    perView: enabled,
                    type: 'carousel',
                }).mount();
            });

            $('.triggering-check', container).change((e) => {
                let check = $(e.currentTarget);
                let url = check.attr('data-triggering-url');
                $.ajax({
                    method: 'GET',
                    url: url,
                    data: {
                        status: check.prop('checked'),
                    },
                });
            });

            $('.iconpicker').iconsPicker();

            map.initMaps(container);
            charting.initCharts(container);
            job.initJobs(container);
            reports_editor.initReportEditor(container);
            reports_render.initReportRenderer(container);
            reports_preview.initReportPreview(container);
            reports_static.initStaticRenderer(container);
        }
    });

    $('input.date').each((index, node) => {
        new Datepicker(node, {
            buttonClass: 'btn',
            format: {
                toValue(date, format, locale) {
                    return Date.parse(date);
                },
                toDisplay(date, format, locale) {
                    return date.toLocaleDateString();
                },
            },
            maxDate: new Date(),
        });
    });

    $('form').submit((e) => {
        let form = $(e.currentTarget);
        graphics.blurForm(form);
        form.find('table.dynamic-table tfoot tr').remove();
    });

    let autoload = $('[name=autoloadmodal]');
    if (autoload.length) {
        j.fetchRemoteModal(autoload.val());
    }

    let savefeedback = $('[name=savefeedback]');
    if (savefeedback.length) {
        let feedback = savefeedback.val();
        if (feedback == 'ok') {
            utils.feedbackToast('Saved!', 'success');
        }
        else {
            utils.feedbackToast('Error!', 'danger');
        }
    }

    /*
        This is to enforce the side offcanvas menu to slide over the sidebar
    */
    $('.offcanvas-start').css('left', $('#side-menu').outerWidth());

    /*
        This is used in conditions where tab selection changes something in the
        rest of the page.
        e.g. selecting a Subscription type, the "new subscription" button must
        link to the newly selected type
    */
    $('.tab-changes-attributes').on('show.bs.tab', (e) => {
        let target = $(e.target).attr('data-change-target');
        let attribute = $(e.target).attr('data-change-attribute');
        let value = $(e.target).attr('data-change-value');
        $(target).attr(attribute, value);
    });

    $('.download-button').click((e) => {
        e.preventDefault();
        let button = $(e.currentTarget);
        let link = $(e.currentTarget);

        let original_text = button.text();
        button.prop('disabled', true).empty().append(j.makeSpinner());

        $.ajax({
            method: 'POST',
            url: link.attr('href'),
            data: link.closest('form').serialize(),
            success: (data) => {
                let a = document.createElement('a');
                let blob = utils.base64ToBlob(data.data, data.mimetype);
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = data.filename;
                a.click();
                window.URL.revokeObjectURL(url);
            },
        }).done(() => {
            button.prop('disabled', false).empty().text(original_text);
        });
    });

    $('.loading-modal').on('show.bs.modal', (e) => {
        let modal = $(e.currentTarget);
        let url = modal.attr('data-loading-url');
        let form = modal.find('form');

        graphics.blurForm(form);

        $.ajax({
            url: url,
            method: 'GET',
            dataType: 'HTML',
            success: (data) => {
                data = $(data);
                form.empty().append(data);
                j.initElements(data);
                graphics.unblurForm(form);
            }
        });
    });
});
